module.exports = __webpack_public_path__ + "08f7dd36bedc0494c6e19e168b5dd9e8.pdf";